import { ContractStatus } from 'app/modules/contracts/contractTypes';
import PagePanel from "../../core/App/PagePanel";
import { LoadingSpinner } from "../../core/components/LoadingSpinner";
import { UserRole, useMeDetailsQuery } from 'legoland-sdk/dist/experimental';
import { useEffect } from 'react';
import { Alert, Box, Heading, Text } from 'tombac';
import { useContractLimitsQuery } from "../contractsApiHooks";
import { ContractProductPackages } from "./ContractProductPackages";
import { ContractProductsList } from "./ContractProductsList";
import ProductForm from "./ProductForm";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ContractProductsContainer = _ref => {
  let {
    contract
  } = _ref;
  const {
    id: contractId,
    products,
    accessType,
    users
  } = contract;
  const meDetailsQuery = useMeDetailsQuery();
  const meDetails = meDetailsQuery.data?.meDetails;
  const creatorRole = meDetails?.role;
  const {
    data: contractLimits,
    isLoading,
    refetch
  } = useContractLimitsQuery({
    contractId
  }, {
    enabled: contractId !== undefined,
    staleTime: 0,
    cacheTime: 0
  });
  useEffect(() => {
    refetch();
  }, [contract.products.length]);
  const productsWithLimits = contractLimits?.products.sort(productAlphabeticComparator);
  const isPackageExists = contractLimits ? Object.entries(contractLimits.package.limits).length > 0 : false;
  const packagedProducts = productsWithLimits?.filter(p => p.product.id === 'ts' || p.product.id === 'od');
  const productIds = packagedProducts?.reduce((acc, current) => {
    return [...acc, current.product.id];
  }, []);
  const canSeePackages = productIds?.includes('ts') && productIds?.includes('od');
  const productsCount = isPackageExists ? productsWithLimits?.filter(p => p.product.id !== 'ts' && p.product.id !== 'od').length : products.length;
  const canSetLimits = creatorRole === UserRole.Admin || creatorRole === UserRole.Distributor;
  const renderProduct = productValues => {
    return /*#__PURE__*/_jsx(ProductForm, {
      isInitialSetup: false,
      onChange: () => {},
      packaged: false,
      showResell: false,
      showAccess: true,
      showProductDetails: false,
      showApiKey: true,
      editableLimits: canSetLimits,
      showInternalOption: true,
      showFreeOption: true,
      showCustomAgreementOption: true
      // NEW PROPS
      ,
      packages: contractLimits?.package,
      productValues: productValues,
      contract: contract,
      "data-sentry-element": "ProductForm",
      "data-sentry-component": "renderProduct",
      "data-sentry-source-file": "ContractProductsContainer.tsx"
    }, productValues.product.id);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [users.length > 1 && /*#__PURE__*/_jsx(Alert, {
      title: '',
      variant: 'info',
      $paddingBottom: "15px",
      children: `Contract's usage limits are shared across all the accounts under
                it.`
    }), canSeePackages && /*#__PURE__*/_jsx(ContractProductPackages, {
      contractId: contractId,
      sharedLimitsPackage: contractLimits?.package,
      isPackageExists: isPackageExists,
      packagedProducts: packagedProducts,
      children: packagedProducts.map(renderProduct)
    }), /*#__PURE__*/_jsxs(Box, {
      $mb: "2sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "ContractProductsContainer.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsxs(Heading, {
        $mb: "2sp",
        as: "h2",
        level: 5,
        "data-sentry-element": "Heading",
        "data-sentry-source-file": "ContractProductsContainer.tsx",
        "data-sentry-element": "Heading",
        children: ["Products (", productsCount, ")"]
      }), /*#__PURE__*/_jsx(PagePanel, {
        $margin: "0",
        breakpoint: 0,
        "data-sentry-element": "PagePanel",
        "data-sentry-source-file": "ContractProductsContainer.tsx",
        "data-sentry-element": "PagePanel",
        children: /*#__PURE__*/_jsx(Box, {
          $display: "flex",
          $flexDirection: "column",
          $gap: "5sp",
          "data-sentry-element": "Box",
          "data-sentry-source-file": "ContractProductsContainer.tsx",
          "data-sentry-element": "Box",
          children: isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : isPackageExists ? productsWithLimits?.filter(p => p.product.id !== 'ts' && p.product.id !== 'od').map(renderProduct) : accessType === 'DISTRIBUTION' ? /*#__PURE__*/_jsx(ContractProductsList, {
            expired: contract.status === ContractStatus.Expired,
            products: products,
            $p: '0'
          }) : productsCount === 0 ? /*#__PURE__*/_jsx(Text, {
            variant: "secondary",
            children: "No products assigned"
          }) : productsWithLimits?.map(renderProduct)
        })
      })]
    })]
  });
};
function productAlphabeticComparator(a, b) {
  const nameA = a.product.displayName.toUpperCase();
  const nameB = b.product.displayName.toUpperCase();
  return nameA.localeCompare(nameB);
}